//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'videoDummy',
  props: ['type', 'ratio', 'orientation', 'count', 'getLoadState', 'minimal', 'relatedItem'],
}
